import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';



export default function CustomSeparator(props) {
  function handleClick(event) {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
  }

  const breadcrumbs = [
    <Link underline="hover" key="1" color="white" href="/" onClick={handleClick}>
      Vocab App
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="white"
      href="/material-ui/getting-started/installation/"
      onClick={handleClick}
    >
      Curriculum
    </Link>,
    <Typography key="3" color="white">
      Word Groups
    </Typography>,
  ];

  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {props.breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}